import { render, staticRenderFns } from "./TransporteTabList.vue?vue&type=template&id=4f10324b&scoped=true"
import script from "./TransporteTabList.vue?vue&type=script&lang=js"
export * from "./TransporteTabList.vue?vue&type=script&lang=js"
import style0 from "./TransporteTabList.vue?vue&type=style&index=0&id=4f10324b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f10324b",
  null
  
)

export default component.exports